import { useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { apiClient, endpoints } from '../api/client';

export const deleteExtensionWorker = async (workerId: string): Promise<void> => {
  await apiClient.delete(`${endpoints.extensionWorkers}/${encodeURIComponent(workerId)}`);
};

export const useDeleteExtensionWorker = () => {
  const queryClient = useQueryClient();
  return useMutation((workerId: string) => deleteExtensionWorker(workerId), {
    onSuccess: () => {
      queryClient.invalidateQueries('extensionWorkers');
      queryClient.invalidateQueries('generalConfig');
      toast.success('Extension worker removed');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.detail || 'Failed to remove extension worker');
    },
  });
};
